import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import configuration from "../../Utility/config.json";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { Link } from "react-router-dom";
import LabelsLoader from "../../Utility/labelsLoader";

function HomeUser(props) {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState({});
  const [isOpen, toggleModal] = useState(false);
  const apiToken = useContext(TokenContext);
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;

  const [announcementsBacheca, setAnnouncementsBacheca] = useState();

  const queryParameters =
    "?returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.host +
    props.subfolder +
    entity_url;
  const labels = LabelsLoader();
  useEffect(() => {
    // 👇️ set isMounted to true
    let isMounted = true;

    async function fetchData() {
      const result = await Promise.resolve(["Unmounted Component"]);

      // 👇️ only update state if component is mounted
      if (isMounted) {
        setLoading(false);

        Repo.getAnnouncementsBacheca(apiToken)
          .then((response) => {
            setAnnouncementsBacheca(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
          });

        Repo.getUserServices(apiToken)
          .then((response) => {
            setServices(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
      }
    }

    fetchData();

    return () => {
      // 👇️ when component unmounts, set isMounted to false
      isMounted = false;
    };
  }, []);

  const loginRedirect = () => {
    window.location.href =
      auth_url + configuration.AUTH_PATH_LOGIN + queryParameters;
  };

  return (
    <>
      <div className="card-body" style={{ textAlign: "center" }}>
        <div className="top-icon">
          <svg className="iicon icon-primary custom-icon">
            <use href={`${iconSprite}#it-link`}></use>
          </svg>
        </div>

        <h5 className="card-title">Accedi con SPID o CIE</h5>
        <p className="card-text">Per accedere ai servizi </p>
        <a href="#" onClick={() => loginRedirect()} data-element="Accedi">
          <button className="btn custom-btn">clicca qui</button>
        </a>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Attenzione!"
        body="Per poterti iscrivere ai servizi devi effettuare il login con SPID o CIE."
        buttonConfirm="Login"
        buttonDeny="Annulla"
        function={() => loginRedirect()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default HomeUser;
